import React from 'react'
import classNames from 'classnames'

import { useApp } from '@/hooks'
import LoadingIndicator from '@/assets/images/loading_indicator.gif'

import AppHeader from './AppHeader'
import AppFooter from './AppFooter'
import '@/assets/scss/appLayout.scss'

interface Props {
  hasFooter?: boolean
  headerRight?: React.ReactNode
  children: React.ReactNode
}

const AppLayout: React.FC<Props> = ({
  hasFooter = false,
  headerRight,
  children,
}) => {
  const { appLoading, isRTL } = useApp()

  return (
    <div
      className={classNames('app-layout', {
        'app-loading': appLoading,
        'rtl-dir': Boolean(isRTL),
      })}
    >
      <AppHeader headerRight={headerRight} />
      <div className="page-content">
        <div className="container">{children}</div>
      </div>
      {appLoading && (
        <div className="loading-wrapper">
          <img src={LoadingIndicator} />
        </div>
      )}
      {hasFooter && <AppFooter />}
    </div>
  )
}

export default AppLayout
